import { createSelector } from 'reselect';

export const getDealersAccesor = state => state.dealers.dealers;

export const dealersSelector = createSelector(getDealersAccesor, dealers => dealers);
